import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiResponseService {

  // Token Key (this is the key used in localStorage)
  private readonly TOKEN_KEY = 'access_token'

  constructor() {}

  getToken(): string | null {
    const token = sessionStorage.getItem(this.TOKEN_KEY);
    return token;
  }

  setToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  removeToken(): void {
    localStorage.removeItem(this.TOKEN_KEY);
  }
}
